const SLIDE_STYLE = {
  opening: 'opening',
  section: 'section',
  plain: 'plain',
  closing: 'closing',
  subSection: 'subSection',
};

const SLIDE_TYPE = {
  graph: 'graph',
  image: 'image',
  station: 'station',
  table: 'table',
};

const SLIDE_CONTENT_TYPE = {
  stationAndMenuItem: 'stationAndMenuItem',
  summaryTable: 'summaryTable',
  issue: 'issue',
};

const WEIGHT_COST_TYPE = {
  weight: 'weight',
  cost: 'cost',
};

const GRAPH_PERIOD_TYPE = {
  day: 'day',
  week: 'week',
  month: 'month',
};

const GRAPH_WASTE_TYPE = {
  weight: 'weight',
  cost: 'cost',
  weightPerCover: 'weightPerCover',
  cover: 'cover',
  throw: 'throw',
};

const GRAPH_WITH_WITHOUT_PRODUCTION = {
  withProduction: 'withProduction',
  withoutProduction: 'withoutProduction',
};

const GRAPH_WIDTH_TYPE = {
  half: 'half',
  normal: 'normal',
  long: 'long',
};

// dynamic property refers to the requirement to multiply slides according to services in that slide category
const ARR_SLIDE_ORDER_TEMPLATE_FOR_BASELINE = [
  { slideStyle: SLIDE_STYLE.opening, dynamic: false },
  {
    slideStyle: SLIDE_STYLE.section,
    dynamic: false,
    headerText: 'Food Waste Review',
    hasTextToAdd: true,
  },
  {
    slideStyle: SLIDE_STYLE.plain,
    headerText: 'TOTAL FOOD WASTE IN TERMS OF WEIGHT (BY MONTHS)',
    dynamic: false,
    slideType: SLIDE_TYPE.graph,
  },
  {
    slideStyle: SLIDE_STYLE.plain,
    headerText: 'SUMMARY - TOTAL LEFTOVER PER COVER',
    dynamic: false,
    slideType: SLIDE_TYPE.table,
  },
  {
    slideStyle: SLIDE_STYLE.plain,
    arrSlideGraphProp: [
      {
        // slideStyle: SLIDE_STYLE.plain,
        headerText: 'LEFTOVER IN TERMS OF WEIGHT AND THROW (BY DAYS)',
        slideType: SLIDE_TYPE.graph,
        dynamic: false,
        isFullWidth: true,
        isDisplayWeight: true,
      },
      {
        // slideStyle: SLIDE_STYLE.plain,
        headerText: 'LEFTOVER IN TERMS OF WEIGHT AND COVER (BY DAYS)',
        slideType: SLIDE_TYPE.graph,
        dynamic: false,
        isFullWidth: true,
        isDisplayWeight: true,
      },
      {
        // slideStyle: SLIDE_STYLE.plain,
        headerText: 'LEFTOVER PER COVER (BY DAYS)',
        slideType: SLIDE_TYPE.graph,
        dynamic: false,
        isFullWidth: true,
      },
    ],
    arrSlideImageProp: [
      {
        headerText: 'TOP WASTED THROWS',
        slideType: SLIDE_TYPE.image,
      },
      {
        headerText: 'TOP 3 LEFTOVER IN TERMS OF WEIGHT',
        slideType: SLIDE_TYPE.image,
      },
    ],
    dynamic: true,
    grouped: true,
  },
  {
    slideStyle: SLIDE_STYLE.subSection,
    headerText: 'FEEDBACK - SINGULAR THROWS',
    dynamic: false,
  },
  {
    slideStyle: SLIDE_STYLE.plain,
    arrSlideProp: [
      {
        headerText: 'SINGULAR THROWS',
        slideType: SLIDE_TYPE.image,
      },
    ],
    dynamic: true,
  },
  {
    slideStyle: SLIDE_STYLE.subSection,
    headerText: 'FEEDBACK - MIXED THROWS',
    dynamic: false,
  },
  {
    slideStyle: SLIDE_STYLE.plain,
    arrSlideProp: [
      {
        headerText: 'MIXED THROWS',
        slideType: SLIDE_TYPE.image,
      },
    ],
    dynamic: true,
  },
  {
    slideStyle: SLIDE_STYLE.subSection,
    headerText: 'FEEDBACK - USAGE ISSUES',
    dynamic: false,
  },
  {
    slideStyle: SLIDE_STYLE.plain,
    arrSlideProp: [
      {
        headerText: 'USAGE ISSUES',
        slideType: SLIDE_TYPE.image,
      },
    ],
    dynamic: true,
  },
  { slideStyle: SLIDE_STYLE.plain, dynamic: false, headerText: 'SUMMARY' },
  { slideStyle: SLIDE_STYLE.section, dynamic: false, headerText: 'Next Steps' },
  // {
  //   slideStyle: SLIDE_STYLE.plain,
  //   arrSlideImageProp: [
  //     {
  //       headerText: 'TOP WASTED THROWS',
  //       slideType: SLIDE_TYPE.image,
  //     },
  //     {
  //       headerText: 'TOP 3 LEFTOVER IN TERMS OF WEIGHT',
  //       slideType: SLIDE_TYPE.image,
  //     },
  //   ],
  //   dynamic: true,
  // },
  { slideStyle: SLIDE_STYLE.closing, dynamic: false },
];

// This map matches the header text to graph name prefix for Baseline Review
const MAP_GRAPH_PREFIX_BY_HEADER_TEXT_FOR_BASELINE = new Map([
  [
    'TOTAL FOOD WASTE IN TERMS OF WEIGHT (BY MONTHS)',
    'BarGraph_Buffet_Leftovers_ByService_ByMonth_Weight',
  ],
  ['LEFTOVER IN TERMS OF WEIGHT AND THROW (BY DAYS)', 'MixedGraph_Throw_Weight_ByDay'],
  ['LEFTOVER IN TERMS OF WEIGHT AND COVER (BY DAYS)', 'MixedGraph_Cover_Weight_ByDay'],
  ['LEFTOVER PER COVER (BY DAYS)', 'MixedGraph_Cover_WeightPerCover_ByDay'],
  ['SINGULAR THROWS', 'notInMenu'],
  ['MIXED THROWS', 'mixed'],
  ['USAGE ISSUES', 'usageIssue'],
]);

const SLIDE_ATTRIBUTE_BY_HEADER_TEXT: Record<string, any> = {
  default: {
    slideStyle: SLIDE_STYLE.plain,
    grouped: false,
  },
  'Opening Slide': {
    slideStyle: SLIDE_STYLE.opening,
  },
  'Closing Slide': {
    slideStyle: SLIDE_STYLE.closing,
  },
  'Food Waste Review': {
    slideStyle: SLIDE_STYLE.section,
  },
  'TOTAL FOOD WASTE IN TERMS OF WEIGHT (BY MONTHS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.graph,
    graphDataAttributes: {
      periodType: GRAPH_PERIOD_TYPE.month,
      barType: GRAPH_WASTE_TYPE.weight,
      withWithoutProduction: GRAPH_WITH_WITHOUT_PRODUCTION.withProduction,
      widthType: GRAPH_WIDTH_TYPE.long,
      includeBreakdown: true,
      isDisplayBarLegend: true,
    },
  },
  'TOTAL LEFTOVER PER COVER (BY MONTHS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.graph,
    graphDataAttributes: {
      periodType: GRAPH_PERIOD_TYPE.month,
      barType: GRAPH_WASTE_TYPE.weightPerCover,
      lineType: GRAPH_WASTE_TYPE.cover,
      withWithoutProduction: GRAPH_WITH_WITHOUT_PRODUCTION.withoutProduction,
      widthType: GRAPH_WIDTH_TYPE.long,
      isDisplayBarLegend: false,
    },
  },
  'TOTAL FOOD WASTE IN TERMS OF WEIGHT (BY LAST 8 WEEKS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.graph,
    graphDataAttributes: {
      periodType: GRAPH_PERIOD_TYPE.week,
      barType: GRAPH_WASTE_TYPE.weight,
      withWithoutProduction: GRAPH_WITH_WITHOUT_PRODUCTION.withProduction,
      widthType: GRAPH_WIDTH_TYPE.normal,
      includeBreakdown: true,
      isDisplayBarLegend: true,
    },
  },
  'TOTAL FOOD WASTE IN TERMS OF COST (BY MONTHS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.graph,
    graphDataAttributes: {
      periodType: GRAPH_PERIOD_TYPE.month,
      barType: GRAPH_WASTE_TYPE.cost,
      withWithoutProduction: GRAPH_WITH_WITHOUT_PRODUCTION.withProduction,
      widthType: GRAPH_WIDTH_TYPE.long,
      includeBreakdown: true,
      isDisplayBarLegend: true,
    },
  },
  'TOTAL FOOD WASTE IN TERMS OF COST (BY LAST 8 WEEKS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.graph,
    graphDataAttributes: {
      periodType: GRAPH_PERIOD_TYPE.week,
      barType: GRAPH_WASTE_TYPE.cost,
      withWithoutProduction: GRAPH_WITH_WITHOUT_PRODUCTION.withProduction,
      widthType: GRAPH_WIDTH_TYPE.normal,
      includeBreakdown: true,
      isDisplayBarLegend: true,
    },
  },
  'LEFTOVER IN TERMS OF WEIGHT AND THROW (BY DAYS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.graph,
    grouped: true,
    graphDataAttributes: {
      periodType: GRAPH_PERIOD_TYPE.day,
      barType: GRAPH_WASTE_TYPE.weight,
      lineType: GRAPH_WASTE_TYPE.throw,
      withWithoutProduction: GRAPH_WITH_WITHOUT_PRODUCTION.withoutProduction,
      widthType: GRAPH_WIDTH_TYPE.long,
      includeBreakdown: true,
      isDisplayBarLegend: true,
    },
  },
  'LEFTOVER IN TERMS OF WEIGHT (BY MONTHS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.graph,
    grouped: true,
    graphDataAttributes: {
      periodType: GRAPH_PERIOD_TYPE.month,
      barType: GRAPH_WASTE_TYPE.weight,
      withWithoutProduction: GRAPH_WITH_WITHOUT_PRODUCTION.withProduction,
      widthType: GRAPH_WIDTH_TYPE.normal,
      includeBreakdown: true,
      isDisplayBarLegend: true,
    },
  },
  'LEFTOVER IN TERMS OF WEIGHT (BY LAST 8 WEEKS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.graph,
    grouped: true,
    graphDataAttributes: {
      periodType: GRAPH_PERIOD_TYPE.week,
      barType: GRAPH_WASTE_TYPE.weight,
      withWithoutProduction: GRAPH_WITH_WITHOUT_PRODUCTION.withProduction,
      widthType: GRAPH_WIDTH_TYPE.normal,
      includeBreakdown: true,
      isDisplayBarLegend: true,
    },
  },
  'LEFTOVER IN TERMS OF WEIGHT AND COVER (BY MONTHS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.graph,
    isExcludeForProduction: true,
    grouped: true,
    graphDataAttributes: {
      periodType: GRAPH_PERIOD_TYPE.month,
      barType: GRAPH_WASTE_TYPE.weight,
      lineType: GRAPH_WASTE_TYPE.cover,
      withWithoutProduction: GRAPH_WITH_WITHOUT_PRODUCTION.withoutProduction,
      widthType: GRAPH_WIDTH_TYPE.normal,
      includeBreakdown: true,
      isDisplayBarLegend: true,
    },
  },
  'LEFTOVER IN TERMS OF WEIGHT AND COVER (BY DAYS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.graph,
    isExcludeForProduction: true,
    grouped: true,
    graphDataAttributes: {
      periodType: GRAPH_PERIOD_TYPE.day,
      barType: GRAPH_WASTE_TYPE.weight,
      lineType: GRAPH_WASTE_TYPE.cover,
      withWithoutProduction: GRAPH_WITH_WITHOUT_PRODUCTION.withoutProduction,
      widthType: GRAPH_WIDTH_TYPE.long,
      includeBreakdown: true,
      isDisplayBarLegend: true,
    },
  },
  'LEFTOVER PER COVER (BY MONTHS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.graph,
    isExcludeForProduction: true,
    grouped: true,
    graphDataAttributes: {
      periodType: GRAPH_PERIOD_TYPE.month,
      barType: GRAPH_WASTE_TYPE.weightPerCover,
      lineType: GRAPH_WASTE_TYPE.cover,
      withWithoutProduction: GRAPH_WITH_WITHOUT_PRODUCTION.withoutProduction,
      widthType: GRAPH_WIDTH_TYPE.normal,
      includeBreakdown: true,
      isDisplayBarLegend: true,
    },
  },
  'LEFTOVER PER COVER (BY LAST 8 WEEKS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.graph,
    isExcludeForProduction: true,
    grouped: true,
    graphDataAttributes: {
      periodType: GRAPH_PERIOD_TYPE.week,
      barType: GRAPH_WASTE_TYPE.weightPerCover,
      lineType: GRAPH_WASTE_TYPE.cover,
      withWithoutProduction: GRAPH_WITH_WITHOUT_PRODUCTION.withoutProduction,
      widthType: GRAPH_WIDTH_TYPE.normal,
      includeBreakdown: true,
      isDisplayBarLegend: true,
    },
  },
  'LEFTOVER PER COVER (BY DAYS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.graph,
    isExcludeForProduction: true,
    grouped: true,
    graphDataAttributes: {
      periodType: GRAPH_PERIOD_TYPE.day,
      barType: GRAPH_WASTE_TYPE.weightPerCover,
      lineType: GRAPH_WASTE_TYPE.cover,
      withWithoutProduction: GRAPH_WITH_WITHOUT_PRODUCTION.withoutProduction,
      widthType: GRAPH_WIDTH_TYPE.long,
      includeBreakdown: true,
      isDisplayBarLegend: true,
    },
  },
  'LEFTOVER IN TERMS OF COST (BY MONTHS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.graph,
    grouped: true,
    graphDataAttributes: {
      periodType: GRAPH_PERIOD_TYPE.month,
      barType: GRAPH_WASTE_TYPE.cost,
      withWithoutProduction: GRAPH_WITH_WITHOUT_PRODUCTION.withProduction,
      widthType: GRAPH_WIDTH_TYPE.normal,
      includeBreakdown: true,
      isDisplayBarLegend: true,
    },
  },
  'LEFTOVER IN TERMS OF COST (BY LAST 8 WEEKS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.graph,
    grouped: true,
    graphDataAttributes: {
      periodType: GRAPH_PERIOD_TYPE.week,
      barType: GRAPH_WASTE_TYPE.cost,
      withWithoutProduction: GRAPH_WITH_WITHOUT_PRODUCTION.withProduction,
      widthType: GRAPH_WIDTH_TYPE.normal,
      includeBreakdown: true,
      isDisplayBarLegend: true,
    },
  },
  SUMMARY: {
    slideStyle: SLIDE_STYLE.subSection,
    slideContentType: SLIDE_CONTENT_TYPE.summaryTable,
  },
  'SUMMARY - TOTAL LEFTOVER IN TERMS OF WEIGHT': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.table,
    slideContentType: SLIDE_CONTENT_TYPE.summaryTable,
  },
  'SUMMARY - TOTAL LEFTOVER IN TERMS OF WEIGHT (w/ YTD)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.table,
    slideContentType: SLIDE_CONTENT_TYPE.summaryTable,
  },
  'SUMMARY - TOTAL LEFTOVER PER COVER': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.table,
    slideContentType: SLIDE_CONTENT_TYPE.summaryTable,
  },
  'SUMMARY - TOTAL LEFTOVER PER COVER (w/ YTD)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.table,
    slideContentType: SLIDE_CONTENT_TYPE.summaryTable,
  },
  'SUMMARY - TOTAL LEFTOVER IN TERMS OF COST': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.table,
    slideContentType: SLIDE_CONTENT_TYPE.summaryTable,
  },
  'SUMMARY - TOTAL LEFTOVER IN TERMS OF COST (w/ YTD)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.table,
    slideContentType: SLIDE_CONTENT_TYPE.summaryTable,
  },
  'SUMMARY - TOTAL LEFTOVER IN TERMS OF WEIGHT (GROUPED)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.table,
    grouped: true,
    slideContentType: SLIDE_CONTENT_TYPE.summaryTable,
  },
  'SUMMARY - TOTAL LEFTOVER IN TERMS OF WEIGHT (GROUPED w/ YTD)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.table,
    grouped: true,
    slideContentType: SLIDE_CONTENT_TYPE.summaryTable,
  },
  'SUMMARY - TOTAL LEFTOVER PER COVER (GROUPED)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.table,
    grouped: true,
    slideContentType: SLIDE_CONTENT_TYPE.summaryTable,
  },
  'SUMMARY - TOTAL LEFTOVER PER COVER (GROUPED w/ YTD)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.table,
    grouped: true,
    slideContentType: SLIDE_CONTENT_TYPE.summaryTable,
  },
  'SUMMARY - TOTAL LEFTOVER IN TERMS OF COST (GROUPED)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.table,
    grouped: true,
    slideContentType: SLIDE_CONTENT_TYPE.summaryTable,
  },
  'SUMMARY - TOTAL LEFTOVER IN TERMS OF COST (GROUPED w/ YTD)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.table,
    grouped: true,
    slideContentType: SLIDE_CONTENT_TYPE.summaryTable,
  },
  'TOP 3 LEFTOVER IN TERMS OF WEIGHT (BY STATIONS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.station,
    weightCostType: WEIGHT_COST_TYPE.weight,
    slideContentType: SLIDE_CONTENT_TYPE.stationAndMenuItem,
    graphDataAttributes: {
      barType: GRAPH_WASTE_TYPE.weight,
      widthType: GRAPH_WIDTH_TYPE.half,
      isDisplayBarLegend: false,
    },
  },
  'TOP 6 LEFTOVER IN TERMS OF WEIGHT IMAGES': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.image,
    weightCostType: WEIGHT_COST_TYPE.weight,
    slideContentType: SLIDE_CONTENT_TYPE.stationAndMenuItem,
  },
  'TOP 6 LEFTOVER IN TERMS OF WEIGHT TABLE': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.table,
    weightCostType: WEIGHT_COST_TYPE.weight,
    slideContentType: SLIDE_CONTENT_TYPE.stationAndMenuItem,
  },
  'TOP 3 LEFTOVER IN TERMS OF COST (BY STATIONS)': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.station,
    weightCostType: WEIGHT_COST_TYPE.cost,
    slideContentType: SLIDE_CONTENT_TYPE.stationAndMenuItem,
    graphDataAttributes: {
      barType: GRAPH_WASTE_TYPE.cost,
      widthType: GRAPH_WIDTH_TYPE.half,
      isDisplayBarLegend: false,
    },
  },
  'TOP 6 LEFTOVER IN TERMS OF COST IMAGES': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.image,
    weightCostType: WEIGHT_COST_TYPE.cost,
    slideContentType: SLIDE_CONTENT_TYPE.stationAndMenuItem,
  },
  'TOP 6 LEFTOVER IN TERMS OF COST TABLE': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.table,
    weightCostType: WEIGHT_COST_TYPE.cost,
    slideContentType: SLIDE_CONTENT_TYPE.stationAndMenuItem,
  },
  'FEEDBACK - SINGULAR THROWS': {
    slideStyle: SLIDE_STYLE.subSection,
  },
  'SINGULAR THROWS': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.image,
    slideContentType: SLIDE_CONTENT_TYPE.issue,
  },
  'FEEDBACK - MIXED THROWS': {
    slideStyle: SLIDE_STYLE.subSection,
  },
  'MIXED THROWS': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.image,
    slideContentType: SLIDE_CONTENT_TYPE.issue,
  },
  'FEEDBACK - USAGE ISSUES': {
    slideStyle: SLIDE_STYLE.subSection,
  },
  'USAGE ISSUES': {
    slideStyle: SLIDE_STYLE.plain,
    slideType: SLIDE_TYPE.image,
    slideContentType: SLIDE_CONTENT_TYPE.issue,
  },
};

const ARR_SLIDE_TEMPLATE = [
  { slideStyle: SLIDE_STYLE.opening },
  {
    arrSlideProp: [
      { slideStyle: SLIDE_STYLE.section, headerText: 'Food Waste Review' },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'TOTAL FOOD WASTE IN TERMS OF WEIGHT (BY MONTHS)',
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'TOTAL LEFTOVER PER COVER (BY MONTHS)',
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'TOTAL FOOD WASTE IN TERMS OF WEIGHT (BY LAST 8 WEEKS)',
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'TOTAL FOOD WASTE IN TERMS OF COST (BY MONTHS)',
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'TOTAL FOOD WASTE IN TERMS OF COST (BY LAST 8 WEEKS)',
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        arrSlideProp: [
          {
            headerText: 'LEFTOVER IN TERMS OF WEIGHT AND THROW (BY DAYS)',
          },
          { headerText: 'LEFTOVER IN TERMS OF WEIGHT (BY MONTHS)' },
          {
            headerText: 'LEFTOVER IN TERMS OF WEIGHT (BY LAST 8 WEEKS)',
          },
          {
            headerText: 'LEFTOVER IN TERMS OF WEIGHT AND COVER (BY MONTHS)',
          },
          {
            headerText: 'LEFTOVER IN TERMS OF WEIGHT AND COVER (BY DAYS)',
          },
          {
            headerText: 'LEFTOVER PER COVER (BY MONTHS)',
          },
          {
            headerText: 'LEFTOVER PER COVER (BY LAST 8 WEEKS)',
          },
          {
            headerText: 'LEFTOVER PER COVER (BY DAYS)',
          },
          { headerText: 'LEFTOVER IN TERMS OF COST (BY MONTHS)' },
          {
            headerText: 'LEFTOVER IN TERMS OF COST (BY LAST 8 WEEKS)',
          },
        ],
        grouped: true,
      },
      {
        slideStyle: SLIDE_STYLE.subSection,
        headerText: 'SUMMARY',
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'SUMMARY - TOTAL LEFTOVER IN TERMS OF WEIGHT',
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'SUMMARY - TOTAL LEFTOVER IN TERMS OF WEIGHT (w/ YTD)',
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'SUMMARY - TOTAL LEFTOVER PER COVER',
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'SUMMARY - TOTAL LEFTOVER PER COVER (w/ YTD)',
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'SUMMARY - TOTAL LEFTOVER IN TERMS OF COST',
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'SUMMARY - TOTAL LEFTOVER IN TERMS OF COST (w/ YTD)',
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'SUMMARY - TOTAL LEFTOVER IN TERMS OF WEIGHT (GROUPED)',
        grouped: true,
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'SUMMARY - TOTAL LEFTOVER IN TERMS OF WEIGHT (GROUPED w/ YTD)',
        grouped: true,
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'SUMMARY - TOTAL LEFTOVER PER COVER (GROUPED)',
        grouped: true,
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'SUMMARY - TOTAL LEFTOVER PER COVER (GROUPED w/ YTD)',
        grouped: true,
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'SUMMARY - TOTAL LEFTOVER IN TERMS OF COST (GROUPED)',
        grouped: true,
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        headerText: 'SUMMARY - TOTAL LEFTOVER IN TERMS OF COST (GROUPED w/ YTD)',
        grouped: true,
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        arrSlideProp: [
          {
            headerText: 'TOP 3 LEFTOVER IN TERMS OF WEIGHT (BY STATIONS)',
            weightCostType: WEIGHT_COST_TYPE.weight,
          },
          {
            headerText: 'TOP 6 LEFTOVER IN TERMS OF WEIGHT IMAGES',
            weightCostType: WEIGHT_COST_TYPE.weight,
          },
          {
            headerText: 'TOP 6 LEFTOVER IN TERMS OF WEIGHT TABLE',
            weightCostType: WEIGHT_COST_TYPE.weight,
          },
          {
            headerText: 'TOP 3 LEFTOVER IN TERMS OF COST (BY STATIONS)',
            weightCostType: WEIGHT_COST_TYPE.cost,
          },
          {
            headerText: 'TOP 6 LEFTOVER IN TERMS OF COST IMAGES',
            weightCostType: WEIGHT_COST_TYPE.cost,
          },
          {
            headerText: 'TOP 6 LEFTOVER IN TERMS OF COST TABLE',
            weightCostType: WEIGHT_COST_TYPE.cost,
          },
        ],
        slideContentType: SLIDE_CONTENT_TYPE.stationAndMenuItem,
      },
      {
        slideStyle: SLIDE_STYLE.subSection,
        headerText: 'FEEDBACK - SINGULAR THROWS',
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        arrSlideProp: [
          {
            headerText: 'SINGULAR THROWS',
          },
        ],
      },
      {
        slideStyle: SLIDE_STYLE.subSection,
        headerText: 'FEEDBACK - MIXED THROWS',
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        arrSlideProp: [
          {
            headerText: 'MIXED THROWS',
          },
        ],
      },
      {
        slideStyle: SLIDE_STYLE.subSection,
        headerText: 'FEEDBACK - USAGE ISSUES',
      },
      {
        slideStyle: SLIDE_STYLE.plain,
        arrSlideProp: [
          {
            headerText: 'USAGE ISSUES',
          },
        ],
      },
    ],
  },
  { slideStyle: SLIDE_STYLE.closing },
];

const ARR_ARR_TOTAL_WEIGHT_SUMMARY_ROW_TEXT = [
  ['Summary'],
  [
    '(a)\n\n',
    'Estimated Food Waste Without Intervention\n',
    'Baseline buffet leftovers per cover multiplied by actual covers served during the period',
  ],
  [
    '(b)\n\n',
    'Actual Food Waste\n',
    'Amount of food waste that is thrown into Lumitics Insight device during the period',
  ],
  [
    '(c)\n\n',
    'Reduction / Increase in Food Waste [KG and %]\n',
    "Difference between 'Forecasted Food Waste' and 'Actual Food Waste' expressed in kg and percentage",
  ],
  [
    '(d)\n\n',
    'Number of Meals Saved\n',
    '“Food Waste Reduction” divided by 0.25 kg (1 kg of food waste is equivalent to 1 meal portion of 0.25 kg)',
  ],
  [
    '(e)\n\n',
    'CO2 Emissions Equivalent Avoided\n',
    '“Food Waste Reduction” multiplied by 2.5 kg (1 kg of food waste contributes to 2.5 kg of CO2 emissions)',
  ],
];

const ARR_ARR_TOTAL_WEIGHT_CALCULATION_ROW_TEXT = [
  ['Calculation'],
  ['baseline buffet leftover per cover x actual covers served'],
  ['-'],
  ['(a) - (b)\n', '[(a) - (b)] ÷ (a) x 100 %'],
  ['(c) ÷ 0.25'],
  ['(c) x 2.5'],
];

const ARR_ARR_TOTAL_LEFTOVER_PER_COVER_SUMMARY_ROW_TEXT = [
  ['Summary'],
  [
    '(a)\n\n',
    'Baseline Leftover Per Cover\n',
    'Baseline amount of food waste that is thrown into Lumitics Insight device divided by number of covers served during baseline',
  ],
  [
    '(b)\n\n',
    'Actual Leftover Per Cover\n',
    'Actual amount of food waste that is thrown into Lumitics Insight device divided by number of covers served during the period',
  ],
  [
    '(c)\n\n',
    'Reduction / Increase in Leftover Per Cover\n',
    "Difference between 'Baseline Leftover Per Cover' and 'Actual Leftover Per Cover' expressed in percentage as compared to 'Baseline Leftover Per Cover'",
  ],
];

const ARR_ARR_TOTAL_LEFTOVER_PER_COVER_CALCULATION_ROW_TEXT = [
  ['Calculation'],
  ['-'],
  ['-'],
  ['(a) - (b)\n', '[(a) - (b)] ÷ (a) x 100 %'],
];

const ARR_ARR_TOTAL_COST_SUMMARY_ROW_TEXT = (currency: string) => [
  ['Summary'],
  [
    '(a)\n\n',
    'Estimated Food Waste Value Without Intervention\n',
    'Baseline food waste value per cover multiplied by actual covers served during the period',
  ],
  [
    '(b)\n\n',
    'Actual Food Waste Value\n',
    'Value of the food waste that is thrown into Lumitics Insight device during the period',
  ],
  [
    '(c)\n\n',
    `Food Waste Savings [${currency} and %]\n`,
    "Difference between 'Estimated Food Waste Value Without Intervention' and 'Actual Food Waste Value' expressed in dollar value and percentage",
  ],
];

const ARR_ARR_TOTAL_COST_CALCULATION_ROW_TEXT = [
  ['Calculation'],
  ['-'],
  ['-'],
  ['(a) - (b)\n', '[(a) - (b)] ÷ (a) x 100 %'],
];

const ARR_SERVICE_ORDER = [
  'all day',
  'all day leftover',
  'all day dining',
  'all day dining leftover',
  'all day buffet',
  'all day buffet leftover',
  'breakfast',
  'breakfast buffet',
  'breakfast buffet leftover',
  'breakfast buffet leftovers',
  'breakfast banquet',
  'breakfast leftovers',
  'breakfast leftover',
  'food to charity',
  'breakfast food to charity',
  'food to donation',
  'f2c breakfast',
  'f2sc breakfast',
  'food to staff canteen',
  'rework breakfast',
  'am coffee break',
  'brunch',
  'brunch buffet',
  'brunch buffet leftover',
  'sunday brunch',
  'sunday brunch leftover',
  'sunday brunch buffet leftover',
  'lunch',
  'lunch buffet',
  'lunch buffet leftover',
  'lunch banquet',
  'lunch banquet leftover',
  'lunch and dinner',
  'f2c lunch',
  'f2sc lunch',
  'rework lunch',
  'afternoon tea',
  'afternoon tea leftover',
  'pm coffee break',
  'tea',
  'dinner',
  'dinner buffet',
  'dinner buffet leftover',
  'dinner banquet',
  'dinner banquet leftover',
  'Dinner food to charity',
  'f2c dinner',
  'f2sc dinner',
  'rework dinner',
  'supper',
  'production',
  'spoilt inventory',
  'delivery supply',
];

const ARR_RANDOM_COLOR: string[] = [
  '9fc5e8',
  '34f4bf',
  'f6a8c1',
  'fbd652',
  '85e113',
  'a195e7',
  'f97a4f',
  'e66dde',
  '4f7bf9',
  'c06e4b',
];

const BAR_CHART_COLORS_FOR_ALL_SERVICES: { [key: string]: { baseline: string; default: string } } =
  {
    'all day': {
      baseline: 'd37890',
      default: 'fc8eac',
    },
    'all day leftover': {
      baseline: '967196',
      default: 'C594C5',
    },
    'all day dining': {
      baseline: '71c010',
      default: '85e113',
    },
    'all day dining leftover': {
      baseline: '789e75',
      default: '98C894',
    },
    'all day buffet': {
      baseline: '4ebdd4',
      default: '5ad7f1',
    },
    'all day buffet leftover': {
      baseline: '537ca6',
      default: '6699CC',
    },
    breakfast: {
      baseline: '4a9396',
      default: '5FB3B3',
    },
    'breakfast buffet': {
      baseline: '43668f',
      default: '5784BA',
    },
    'breakfast buffet leftover': {
      baseline: '00a3b9',
      default: '00cae6',
    },
    'breakfast buffet leftovers': {
      baseline: '4fa0c3',
      default: '62c6f1',
    },
    'breakfast banquet': {
      baseline: '754eae',
      default: '8e5ed4',
    },
    'breakfast leftovers': {
      baseline: '8b81c9',
      default: 'a195e7',
    },
    'breakfast leftover': {
      baseline: 'b35ccb',
      default: 'd368f0',
    },
    'food to charity': {
      baseline: '805865',
      default: 'A57283',
    },
    'breakfast food to charity': {
      baseline: '1F7A6D',
      default: '2A9D8F',
    },
    'food to donation': {
      baseline: 'E89C9F',
      default: 'FFB6B9',
    },
    'f2c breakfast': {
      baseline: '6fb0b6',
      default: '8ddfe6',
    },
    'f2sc breakfast': {
      baseline: '2A7EB5',
      default: '3498DB',
    },
    'food to staff canteen': {
      baseline: '8d9cae',
      default: 'a8bacf',
    },
    'rework breakfast': {
      baseline: '4764d1',
      default: '5377fc',
    },
    'am coffee break': {
      baseline: 'a84c82',
      default: 'c45998',
    },
    brunch: {
      baseline: 'd1ccb9',
      default: 'f0ead6',
    },
    'brunch buffet': {
      baseline: 'ae4563',
      default: 'de527a',
    },
    'brunch buffet leftover': {
      baseline: 'E9967A',
      default: 'FFA07A',
    },
    'sunday brunch': {
      baseline: 'd96055',
      default: 'FF6F61',
    },
    'sunday brunch leftover': {
      baseline: '89b623',
      default: 'a5db2b',
    },
    'sunday brunch buffet leftover': {
      baseline: '36ad69',
      default: '2ECC71',
    },
    lunch: {
      baseline: 'd47b4a',
      default: 'FA9157',
    },
    'lunch buffet': {
      baseline: 'be5e3d',
      default: 'f97a4f',
    },
    'lunch buffet leftover': {
      baseline: 'c24e54',
      default: 'EC5F67',
    },
    'lunch banquet': {
      baseline: 'D88C47',
      default: 'F4A261',
    },
    'lunch banquet leftover': {
      baseline: 'b43a3a',
      default: 'd64545',
    },
    'lunch and dinner': {
      baseline: 'd9b947',
      default: 'fbd652',
    },
    'f2c lunch': {
      baseline: 'd14326',
      default: 'fb502e',
    },
    'f2sc lunch': {
      baseline: 'cc5a6f',
      default: 'f16a83',
    },
    'rework lunch': {
      baseline: 'c17d3e',
      default: 'ee9a4d',
    },
    'afternoon tea': {
      baseline: 'bc59b6',
      default: 'e66dde',
    },
    'afternoon tea leftover': {
      baseline: 'cb8b9f',
      default: 'f6a8c1',
    },
    'pm coffee break': {
      baseline: '7688A9',
      default: '92A8D1',
    },
    tea: {
      baseline: 'a6d497',
      default: 'bdf1ac',
    },
    dinner: {
      baseline: 'd4a953',
      default: 'FAC862',
    },
    'dinner buffet': {
      baseline: '2bcb9f',
      default: '34f4bf',
    },
    'dinner buffet leftover': {
      baseline: '639aa5',
      default: '80c4d1',
    },
    'dinner banquet': {
      baseline: '4a984f',
      default: '5dbb63',
    },
    'dinner banquet leftover': {
      baseline: 'b0c336',
      default: 'd3eb3d',
    },
    'Dinner food to charity': {
      baseline: '7bb195',
      default: '9FE2BF',
    },
    'f2c dinner': {
      baseline: '6D8C3A',
      default: '9bcf4c',
    },
    'f2sc dinner': {
      baseline: 'ccc365',
      default: 'fff380',
    },
    'rework dinner': {
      baseline: 'cb9009',
      default: 'f4ad0b',
    },
    supper: {
      baseline: '66c95f',
      default: '77e96e',
    },
    production: {
      baseline: 'd1b98c',
      default: 'f1d6a2',
    },
    'spoilt inventory': {
      baseline: '98573c',
      default: 'c06e4b',
    },
    'delivery supply': {
      baseline: '808080',
      default: 'C0C0C0',
    },
    'option 1': {
      baseline: 'd09c04',
      default: 'FFBF00',
    },
    'option 2': {
      baseline: '8a6151',
      default: 'AC7966',
    },
    'option 3': {
      baseline: 'a46ec4',
      default: 'c081e6',
    },
    'option 4': {
      baseline: '5277c9',
      default: '6693F5',
    },
    'option 5': {
      baseline: '00b90a',
      default: '00e30d',
    },
  };

const WHITE_COLOR = '#FFFFFF';
const DEFAULT_ZEROLINE_COLOR = 'A0A0A0';
const DEFAULT_GRIDLINE_COLOR = 'EBEBEB';
const DEFAULT_WORD_COLOR_NAVY = '0F2647';
const DEFAULT_TOP_LABEL_COLOR = 'EB706E';
const LINE_CHART_COLOR = '6E6F71';

export {
  ARR_ARR_TOTAL_COST_CALCULATION_ROW_TEXT,
  ARR_ARR_TOTAL_COST_SUMMARY_ROW_TEXT,
  ARR_ARR_TOTAL_LEFTOVER_PER_COVER_CALCULATION_ROW_TEXT,
  ARR_ARR_TOTAL_LEFTOVER_PER_COVER_SUMMARY_ROW_TEXT,
  ARR_ARR_TOTAL_WEIGHT_CALCULATION_ROW_TEXT,
  ARR_ARR_TOTAL_WEIGHT_SUMMARY_ROW_TEXT,
  ARR_RANDOM_COLOR,
  ARR_SERVICE_ORDER,
  ARR_SLIDE_TEMPLATE,
  ARR_SLIDE_ORDER_TEMPLATE_FOR_BASELINE,
  SLIDE_ATTRIBUTE_BY_HEADER_TEXT,
  BAR_CHART_COLORS_FOR_ALL_SERVICES,
  DEFAULT_ZEROLINE_COLOR,
  DEFAULT_GRIDLINE_COLOR,
  DEFAULT_WORD_COLOR_NAVY,
  DEFAULT_TOP_LABEL_COLOR,
  GRAPH_PERIOD_TYPE,
  GRAPH_WASTE_TYPE,
  GRAPH_WITH_WITHOUT_PRODUCTION,
  GRAPH_WIDTH_TYPE,
  LINE_CHART_COLOR,
  SLIDE_CONTENT_TYPE,
  SLIDE_STYLE,
  SLIDE_TYPE,
  MAP_GRAPH_PREFIX_BY_HEADER_TEXT_FOR_BASELINE,
  WEIGHT_COST_TYPE,
  WHITE_COLOR,
};
